export default "__VITE_ASSET__BYsdfwHg__"